import Param from './param';
import Util from './module/libs/util';
import effectManager from './module/effect';
import globalNavi from './module/global/globalNavi';
import topManager from './page/top';
import spTurnDevice from './module/global/spTurnDevice';

const param = new Param();
const util = new Util();
let effect;
let gNavi;
let toppage;
let turnDevice = new spTurnDevice(Useragnt.mobile || Useragnt.tablet? "sp":"pc");

// const stats = new Stats();
// stats.showPanel( 0 );
// document.body.appendChild( stats.dom );

let pageID = document.body.id;
let fpsRate = 0;
let executionType = "landing"; /* 実行タイミングの制御用 */
let _w = 0;
let _h = 0;
let _x = 0;
let _y = 0;
let _dir = '';

//element
let _html = document.querySelector('html');

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {

    if(!requestAnimationFrame){
        setTimeout(() => {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }

    fpsRate = util.updateTimeRatio();

    //stats.begin();

    //stats.end();

}


/* ---------------------------------------------------

  -- common

 --------------------------------------------------- */


let common = function (type) {

    effect = new effectManager();
    gNavi = new globalNavi(param);
    toppage = new topManager(effect);

    gNavi.init();

    setTimeout(() => {
        pageManager(pageID);
        resize();
        render();
    },'1e3');

}

let pageManager = function(type){

    TweenMax.to(window, 0, {
        scrollTo : { y: 0, autoKill:false },
    });

    toppage.init();

}

let resize = function () {

    _h = window.innerHeight;

    gNavi.resize(_h);

}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

window.addEventListener('DOMContentLoaded', function() {
    TweenMax.to(window, 0, {
        scrollTo : { y: 0, autoKill:false },
    });
    common("landing");
});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

/* scroll */
document.addEventListener('scroll', function(e) {

    _y = window.pageYOffset || document.documentElement.scrollTop;
    gNavi.change(_y);

}, {passive: false});

/* [ SMP Tablet用 ]
 ------------------------------------*/

let touchInc = {
    x : 0,
    y : 0,
    pos : 0,
}

window.addEventListener("touchstart",function (e) {
    touchInc.x = e.touches[0].pageX;
    touchInc.y = e.touches[0].pageY;
});
window.addEventListener("touchmove",function (e) {
});
window.addEventListener("touchend",function (e) {

});



/* [ keyboard 用 ]
 ------------------------------------*/

document.addEventListener('keyup',function(e){

    if(e.keyCode == 40 || e.keyCode == 34 ){

        _dir = 'next';
        scrollEvent();

    }else if(e.keyCode == 38 || e.keyCode == 33){

        _dir = 'prev';
        scrollEvent();

    }

});

window.addEventListener('resize', resize, false);
window.addEventListener('onorientationchange', resize, false);